import { render, staticRenderFns } from "./workflowManageList.vue?vue&type=template&id=3f133a7a&scoped=true"
import script from "./workflowManageList.vue?vue&type=script&lang=js"
export * from "./workflowManageList.vue?vue&type=script&lang=js"
import style0 from "./workflowManageList.vue?vue&type=style&index=0&id=3f133a7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f133a7a",
  null
  
)

export default component.exports